// Constants
import { WebQueryParams } from "@ms/uno-constants/lib/local/WebConstants";
// Utilities
import { DeepLinkSubRouteKeys } from "@ms/uno-routing/lib/local/utilities/DeepLinkUtils";
/**
 * Coarse shape of a URL path that no parser could turn into a route.
 * Values are shapes only and never carry identifiers, so they are safe to log.
 */ export var UnresolvedDeepLinkShape = /*#__PURE__*/ function(UnresolvedDeepLinkShape) {
    UnresolvedDeepLinkShape["None"] = "none";
    UnresolvedDeepLinkShape["V1"] = "v1";
    /** Resolving this needs an authenticated group-to-plan lookup, so no parser handles it */ UnresolvedDeepLinkShape["LegacyGroup"] = "legacyGroup";
    UnresolvedDeepLinkShape["LegacyPlanViews"] = "legacyPlanViews";
    UnresolvedDeepLinkShape["LegacyTask"] = "legacyTask";
    UnresolvedDeepLinkShape["LegacyPlanner"] = "legacyPlanner";
    UnresolvedDeepLinkShape["LegacyOther"] = "legacyOther";
    UnresolvedDeepLinkShape["Unknown"] = "unknown";
    return UnresolvedDeepLinkShape;
}({});
/** Legacy path segments in precedence order; "/home/planner" must not shadow "/home/planviews" */ const legacyShapesBySegment = [
    [
        "/home/group",
        "legacyGroup"
    ],
    [
        "/home/planviews",
        "legacyPlanViews"
    ],
    [
        "/home/task",
        "legacyTask"
    ],
    [
        "/home/planner",
        "legacyPlanner"
    ],
    [
        "/home/",
        "legacyOther"
    ]
];
/**
 * Classifies a URL path that produced no route, so unresolved deep links can be measured by shape.
 * Separates "the app was opened normally" (None) from "a link was followed that we could not
 * resolve", which telemetry cannot otherwise distinguish.
 * @param pathname URL path, already stripped of the active web URL prefix
 */ export function classifyUnresolvedDeepLink(pathname) {
    const path = pathname.trim().toLowerCase();
    if (path === "" || path === "/") {
        return "none";
    }
    if (path === `/${DeepLinkSubRouteKeys.V1}` || path.startsWith(`/${DeepLinkSubRouteKeys.V1}/`)) {
        return "v1";
    }
    return legacyShapesBySegment.find(([segment])=>path.includes(segment))?.[1] ?? "unknown";
}
export function getLocale() {
    // Here's the priority order for locale
    // 1) "mkt" query parameter override
    // 3) Browser's language
    // 4) Default to "en-US" (shouldn't happen)
    const queryParams = new URLSearchParams(window.location.search);
    const mktFromQuery = queryParams.get(WebQueryParams.Mkt);
    if (mktFromQuery) {
        return mktFromQuery;
    }
    const browserLanguage = navigator?.language;
    if (browserLanguage) {
        return browserLanguage;
    }
    return "en-US";
}
